import React from 'react';

import ChoiceSingle from './ChoiceSingle'


export default class ChoiceMultiple extends ChoiceSingle {
}
